( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'scrolling-step-cards', COMPONENT );
} )( app );
